let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6YVCS")).then(() => parcelRequire('49xmL'));